(() => {
  const roots = document.querySelectorAll('[data-tcg-offer]');
  if (!roots.length) return;

  const formatMoney = (cents) => {
    const fmt = window.Kl24EuroFormat;
    if (fmt) return fmt.formatFromCents(cents);
    return String(
      new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(
        (Number(cents) || 0) / 100
      )
    ).replace(/\s+€/g, '€');
  };

  roots.forEach((root) => {
    const apiBase = (root.dataset.apiBase || '').replace(/\/$/, '');
    const listPriceCents = Number(root.dataset.listPriceCents || 0);
    const minOfferCents = Number(root.dataset.minOfferCents || 100);

    const openBtn = root.querySelector('[data-offer-open]');
    const overlay = root.querySelector('[data-offer-overlay]');
    const closeBtn = root.querySelector('[data-offer-close]');
    const form = root.querySelector('[data-offer-form]');
    const feedback = root.querySelector('[data-offer-feedback]');
    const submitBtn = root.querySelector('[data-offer-submit]');
    const offerInput = root.querySelector('[data-offer-input]');

    if (!openBtn || !overlay || !form) return;

    if (offerInput) {
      const suggested = Math.max(minOfferCents, Math.floor(listPriceCents * 0.9));
      offerInput.placeholder = (suggested / 100).toFixed(2).replace('.', ',');
    }

    const open = () => {
      overlay.hidden = false;
      document.body.style.overflow = 'hidden';
      offerInput?.focus();
    };

    const close = () => {
      overlay.hidden = true;
      document.body.style.overflow = '';
    };

    const showFeedback = (message, type) => {
      if (!feedback) return;
      feedback.hidden = false;
      feedback.textContent = message;
      feedback.classList.remove('is-error', 'is-success');
      feedback.classList.add(type === 'success' ? 'is-success' : 'is-error');
    };

    openBtn.addEventListener('click', open);
    closeBtn?.addEventListener('click', close);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) close();
    });

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!apiBase) {
        showFeedback(
          'Angebots-API ist noch nicht konfiguriert. Bitte Theme-Einstellung „Cockpit API URL“ setzen.',
          'error'
        );
        return;
      }

      const offerEur = Number(String(offerInput?.value || '').replace(',', '.'));
      if (!Number.isFinite(offerEur) || offerEur <= 0) {
        showFeedback('Bitte einen gültigen Betrag eingeben.', 'error');
        return;
      }

      const offerCents = Math.round(offerEur * 100);
      if (offerCents >= listPriceCents) {
        showFeedback(`Dein Angebot muss unter ${formatMoney(listPriceCents)} liegen.`, 'error');
        return;
      }
      if (offerCents < minOfferCents) {
        showFeedback(`Mindestangebot: ${formatMoney(minOfferCents)}.`, 'error');
        return;
      }

      const email = root.querySelector('[data-offer-email]')?.value?.trim();
      const message = root.querySelector('[data-offer-message]')?.value?.trim();

      if (!email) {
        showFeedback('Bitte E-Mail angeben.', 'error');
        return;
      }

      submitBtn.disabled = true;
      showFeedback('Angebot wird gesendet …', 'success');

      const payload = {
        product_sku: root.dataset.productSku || 'unknown',
        product_title: root.dataset.productTitle || 'Produkt',
        shopify_product_id: `gid://shopify/Product/${root.dataset.shopifyProductId}`,
        shopify_variant_id: `gid://shopify/ProductVariant/${root.dataset.shopifyVariantId}`,
        list_price_cents: listPriceCents,
        offer_price_cents: offerCents,
        customer_email: email,
        customer_message: message || null,
      };

      try {
        const response = await fetch(`${apiBase}/offers`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          const body = await response.json().catch(() => ({}));
          const detail = body.detail || 'Angebot konnte nicht gesendet werden.';
          throw new Error(typeof detail === 'string' ? detail : 'Angebot fehlgeschlagen.');
        }

        showFeedback(
          'Danke! Wir melden uns in Kürze per E-Mail – dein Angebot liegt bei uns im Cockpit.',
          'success'
        );
        form.reset();
      } catch (error) {
        showFeedback(error.message || 'Netzwerkfehler. Bitte später erneut versuchen.', 'error');
      } finally {
        submitBtn.disabled = false;
      }
    });
  });
})();
